import React, { useEffect, useState } from "react";
import "../../assets/css/--page-vendors.css";

import logo from "../../assets/images/mains-logo.png";
import arrow from "../../assets/images/arrow.png";

import { getAllVendorsCategoryWise } from "../../helper/backend-methods";
import AppLoader from "../../components/AppLoader";
import ScrollToTop from "../../components/ScrollToTop";
import { useNavigate } from "react-router-dom";

export default function AllVendorsPage() {
  const [vendorSections, setVendorSections] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      setLoading(true);

      const response = await getAllVendorsCategoryWise({
        store: 2,
      });
      const apiData = response?.data?.Data || [];

      const mappedData = apiData.map((category) => ({
        id: `category-${category.CategoryId}`,
        categoryId: category.CategoryId,
        menuName: category.CategoryName,
        title: `${category.CategoryName.toUpperCase()} VENDORS`,
        vendors: category.CategoryVendors || [],
      }));

      setVendorSections(mappedData);

      if (mappedData.length > 0) {
        setActiveCategory(mappedData[0].id);
      }
    } catch (error) {
      console.error("Vendor API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = (e, id) => {
    e.preventDefault();

    setActiveCategory(id);

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  if (loading) {
    return (
      <div className="loading-container" style={{ marginTop: "100px" }}>
        <AppLoader />
      </div>
    );
  }

  return (
    <main id="store-all-vendors-page">
      <div className="wrapper">
        <div className="store-vendors-breadcrumb">
          <span onClick={() => navigate("/store")}>Store Items</span>

          <span className="breadcrumb-arrow"></span>

          <strong>All Vendors</strong>
        </div>

        <div className="store-vendors-layout">
          <aside className="store-vendors-sidebar">
            <h4>ALL VENDORS</h4>

            {vendorSections.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                onClick={(e) => handleCategoryClick(e, section.id)}
                className={activeCategory === section.id ? "active" : ""}
              >
                {section.menuName}
              </a>
            ))}
          </aside>

          <div className="store-vendors-content">
            {vendorSections.map((section) => (
              <section key={section.id} id={section.id} className="store-vendors-section">
                <div className="store-vendors-section-header">
                  <h2>{section.title}</h2>

                  <button type="button" onClick={() => navigate("/store")}>
                    SEE WHAT’S IN STORE
                    <img src={arrow} width={18} height={11} alt="arrow" />
                  </button>
                </div>

                {section.vendors?.length > 0 ? (
                  <div className="store-vendors-grid">
                    {section.vendors.map((vendor) => (
                      <div key={`${section.categoryId}-${vendor.VendorId}`} className="store-vendor-card">
                        <img src={vendor.VendorPicture?.Url || logo} alt={vendor.VendorName} />

                        <h3>{vendor.VendorName}</h3>

                        <p>{vendor.VendorDescription || "No description available."}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="store-vendors-empty">No vendors available.</div>
                )}
              </section>
            ))}
          </div>
        </div>
      </div>
      <ScrollToTop />
    </main>
  );
}
